module.exports = __webpack_public_path__ + "static/media/doc.4ffa1307.png";